export default __webpack_public_path__ + "static/media/mef-logo.378102af.png";